import { useEffect, useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

type Options = {
  exclude?: string[];
  behavior?: ScrollBehavior;
  top?: number;
  enabled?: boolean;
};

export function useScrollToTop({
  exclude = [],
  behavior = 'smooth',
  top = 0,
  enabled = true,
}: Options = {}) {
  const { pathname } = useLocation();

  const isExcluded = useMemo(() => {
    return exclude.some((pattern) =>
      matchPath({ path: pattern, end: !pattern.endsWith('/*') }, pathname)
    );
  }, [exclude, pathname]);

  useEffect(() => {
    if (!enabled || isExcluded) return;
    window.scrollTo({ top, behavior });
  }, [pathname, enabled, isExcluded, top, behavior]);
}
